import Swal from 'sweetalert2/dist/sweetalert2.esm.js'
import domLoaded from 'dom-loaded';
import ky from 'ky';

const swalBase = Swal.mixin({
  customClass: {
    htmlContainer: 'border-top',
  },
  animation: false,
  showConfirmButton: false,
  showCloseButton: true,
});

domLoaded.then(() => {
  // add a nice tool tip to glossary links
  document.querySelectorAll('a.glossary').forEach((linkEl) => {
    linkEl.title = 'Click for definition';
  });

  // event handler to load glossary and open dialog when you click on a glossary link
  document.addEventListener('click', function(event) {
    const linkEl = event.target.closest('a.glossary');
    if (linkEl === null) {
      return;
    }

    // Don't follow the link.
    event.stopPropagation();
    event.preventDefault();

    // Open the modal for the definition.
    swalBase.fire({
      willOpen: async () => {
        // Show a loading spinner until fetch is complete.
        swalBase.showLoading();

        // Look for the glossary term as a data attribute first (for a few
        // simple use-cases in the legacy PREP tool where we just want to
        // inline the definition).
        let termAnchor = linkEl.dataset.glossaryTerm;
        if (!termAnchor) {
          // The double decode URI component is due to the fact that the IDs on
          // the page are url encoded, and in order to link to those, we need
          // to actually url-encode the hash. All of this is a bit funky and
          // could be made simpler if we adopted simpler anchors without
          // special characters, but currently leaving this for compatibility.
          termAnchor = decodeURIComponent(decodeURIComponent(linkEl.hash.replace(/^#/, '')));
        }
        let term = termAnchor;
        let definition = linkEl.dataset.glossaryDefinition;

        // Request the term definition from the ajax endpoint if it wasn't set
        // via the data attribute.
        if (!definition) {
          const url = new URL(linkEl.href);
          if (termAnchor) {
            url.searchParams.set('term', termAnchor);
          }
          const resp = await ky.get(url).json();
          term = resp[termAnchor].term;
          definition = resp[termAnchor].definition;
        }

        // Update the modal with the definition.
        swalBase.update({
          title: term,
          html: definition,
        })
      },
    });
  });
});
